import ApplicationController from "application_controller.js";

export default class extends ApplicationController {
  debug = false;

  static values = {
    type: String,
    action: String,
    name: String,
    value: String,
    data: Object,
    trigger: { type: String, default: "click" },
    once: { type: Boolean, default: true },
  };

  connect() {
    this.log_function("connect");

    switch (this.triggerValue) {
      case "click":
        this.onTriggerEvent = this.triggerEvent.bind(this);
        this.element.addEventListener("click", this.onTriggerEvent, { once: this.onceValue });
        break;
      case "hover":
        this.onTriggerEvent = this.triggerEvent.bind(this);
        this.element.addEventListener("mouseover", this.onTriggerEvent, { once: this.onceValue });
        break;
      case "connect":
        this.triggerEvent();
        break;
      default:
        this.log_error_function("connect", `Event trigger "${this.triggerValue}" doesn't exist.`);
        break;
    }
  }

  triggerEvent(){
    this.log_function("triggerEvent");

    if(this.hasTypeValue && this.typeValue !== ""){
      this.log_function("triggerEvent", "analytics/google -- dispatching event");
      let eventDetails = {
        type: this.typeValue,
        ...this.dataValue,
      };

      if(this.hasActionValue && this.actionValue !== ""){
        eventDetails["action"] = this.actionValue;
      }

      if(this.hasNameValue && this.nameValue !== ""){
        eventDetails["name"] = this.nameValue;
      }

      if(this.hasValueValue && this.valueValue !== ""){
        eventDetails["value"] = this.valueValue;
      }

      this.log_function("triggerEvent", "analytics/google", eventDetails);

      this.dispatch("googleAnalytics_trackEvent", {
        detail: eventDetails,
        prefix: false,
      });

    } else {
      this.log_error_function("analytics", "You haven't provided require event values.");
      return false;
    }
  }

  disconnect(){
    this.log_function("disconnect");

    switch (this.triggerValue) {
      case "click":
        this.element.removeEventListener("click", this.onTriggerEvent);
        break;
      case "hover":
        this.element.removeEventListener("mouseover", this.onTriggerEvent);
        break;
    }
  }
}
